import React, { useState } from 'react';
import { Menu, Dropdown, Badge, Avatar, List, Input, Divider, Tooltip, Skeleton } from 'antd';
import { 
  SearchOutlined
} from '@ant-design/icons';
import Flex from 'components/shared-components/Flex'
import Utils from 'utils';
import SamacLib from 'lib/samac';
import "./NavSearchUsers.css"
import FaUserMagnifying from 'icons/faUserMagnifying';

export const NavSearchUsers = (props) => {
  const [visible, setVisible] = useState(false);
  const [presences, setPresences] = useState([])
  const [filter, setFilter] = useState("")
  
  let getBadgeInfo = (presenceToday, isColor) => {
    let rv = "";
    let color = "#f2f2f2";
    let text = "N.D.";
    switch(presenceToday)
    {
      case 1: color = "#8dbf4f"; text = "Presente"; break;
      case 2: color = "#f09636"; text = "SmartWorking"; break;
      case 3: color = "#4988f7"; text = "Trasferta"; break;
      case 10: color = "#c23227"; text = "Assente"; break;
      default: break;
    }

    rv = isColor ? color : text;
    return rv;
  }

  let handleInputChange = (e) => {
    setFilter(e.target.value);
  }

  const getUsersBody = () => {
    return presences.length > 0 ?
    <>
    <div>
    <div>
    <Input allowClear={true} style={{boxShadow: "none", borderColor: "white"}} prefix={<SearchOutlined />} onChange={(e) => handleInputChange(e)} placeholder="Cerca collega"></Input>
    <Divider style={{margin: "0", borderTop: "2px solid #e6ebf1"}}></Divider>
    </div>
    <div style={{height: "15rem", overflowY: "auto"}}><List
      size="small"
      itemLayout="horizontal"
      dataSource={presences.filter(p => filter !== "" && filter.length > 1 ? (p.firstName.toLowerCase().includes(filter.toLowerCase()) || p.lastName.toLowerCase().includes(filter.toLowerCase())) : p.presenceToday === 10)}
      renderItem={item => (
          <List.Item className="list-clickable">
            <Flex>
              <Tooltip title={getBadgeInfo(item.presenceToday)}>
               <Badge dot style={{transition: "none", background: getBadgeInfo(item.presenceToday, true), transform: "translate(30%, 175%)", height: "0.6rem", width: "0.6rem"}}>
                <Avatar src={Utils.completeB64Image(item.avatarLight)} size={24} />
              </Badge>
              </Tooltip>
                <span style={{marginTop: ".15rem"}}>&nbsp;&nbsp;<b>{item.fullName}</b></span>
            </Flex>
          </List.Item>
      )}
    />
    </div>
    </div>
    </>
    :
    <div className="empty-notification">
      <Skeleton style={{padding: "0 2rem 0 2rem"}}></Skeleton>
    </div>;
  }

  const handleVisibleChange = (flag) => {
    setVisible(flag);
    if(flag)
    {
      SamacLib.GetRequest("/users/today/presences").then((body) => {
        setPresences(body);
      });
    }
  }

  const usersList = (
    <div className="nav-dropdown nav-notification">
      <div className="nav-notification-header d-flex justify-content-between align-items-center" style={{padding: "0.25rem"}}>
        <h4 className="mb-1 mt-2 ml-2">Presenze Colleghi</h4>
        {/*<Button className="text-primary" style={{marginRight: "-0.25rem"}} type="link" onClick={() => setData([])} size="small">Cancella tutte</Button>*/}
      </div>
      <div className="nav-notification-body">
        {getUsersBody()}
      </div>
    </div>
  );

  return (
    <Dropdown 
      placement="bottomRight"
      overlay={usersList}
      onVisibleChange={handleVisibleChange}
      visible={visible}
      trigger={['click']}
      getPopupContainer={trigger => trigger.parentNode}
    >
      <Menu mode="horizontal">
        <Menu.Item key="usersPresences">
          <FaUserMagnifying height={22} fill={"#455560"} style={{marginTop: "1.4rem"}}></FaUserMagnifying>
        </Menu.Item>
      </Menu>
    </Dropdown>
  )
}


export default NavSearchUsers;
